import React, { Component } from 'react';
import { Table,Button,Input, Row, Col,Select,Menu,Icon,Modal,Form,DatePicker,message,Radio, Breadcrumb} from 'antd';
import {action} from './'
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import {getFilterColumns} from './columns'
import axios from 'axios';
import $ from '$';
import API from '../../../../API/api';
import CreateTask from "./creat_task/view";

const Search = Input.Search;
const Option = Select.Option;
const confirm = Modal.confirm;


const STAGE_MAP = {
    pre_assign: 0,
    img_explain: 10,
    pre_img_explain_check: 20,
    img_explain_check: 30,
    img_explain_rework: 32,
    pre_text_explain: 100,
    text_explain: 110,
    pre_text_explain_check: 120,
    text_explain_check: 130,
    text_explain_rework: 132,
    text_explain_pass: 200,
    text_explain_onlineing: 1003,
    text_explain_online_success: 1001,
    text_explain_online_fail: 1002,
}

const STAGE_MAP_REVERES = [
    'pre_assign',
    'img_explain',
    'pre_img_explain_check',
    'img_explain_check',
    'img_explain_rework',
    'pre_text_explain',
    'text_explain',
    'pre_text_explain_check',
    'text_explain_check',
    'text_explain_rework',
    'text_explain_pass',
    'text_explain_onlineing',
    'text_explain_online_success',
    'text_explain_online_fail',
]

class MissionList extends Component{
    state={
        advanceSearch:false,

        search:'',
        page:1,
        pagesize:20,
        searchType:'0',
        pic_check_user:'',//高级搜索时选中的审核人
        pic_user:'',
        text_check_user:'',
        text_user:'',

        taskList:[],
        visible:false,
        totalWidth:1002,
        selectedRowKeys: [], // Check here to configure the default column

        assignImgGroup:false,//模态框的开关
        assignImgClerk:false,
        modAssignImgClerk:false,
        assignImgClerkCheck:false,
        assignTextClerk:false,
        assignTextGroup:false,
        modAssignTextClerk:false,
        assignTextClerkCheck:false,

        imgGroupList:'',//分配图片组
        imgGroup:'',
        imgClerkList:'',//分配编写解析员
        imgClerk:'',
        imgClerkCheckList:'',//分配编写审核员
        imgClerkCheck:'',//分配编写审核员

        textGroupList:'',//录解析组
        textGroup:'',//录解析组
        textClerkList:'',//录解析员
        textClerk:'',//录解析员
        textClerkCheckList:'',//分配录审核员
        textClerkCheck:'',//分配录审核员

        exportStatic:false,//导出
        exportStartTime:'',
        exportEndTime:'',
        imgExplainSubmitNotAllDo:false,//编写解析提交时为完成所有题目时提示的modal
    }
    columnsToDisplay={
        pre_assign:[],
        img_explain:[],
        pre_img_explain_check:[],
        img_explain_check:[],
        img_explain_rework:[],
        pre_text_explain:[],
        text_explain:[],
        pre_text_explain_check:[],

        text_explain_check:[],
        text_explain_rework:[],

        text_explain_pass:[],
        text_explain_onlineing:[],
        text_explain_online_success:[],
        text_explain_online_fail:[],
    }



    componentWillReceiveProps(newProps){
        if(this.props.user!=newProps.user) {
            let role_qexplain = newProps.user.role_qexplain
            if (!role_qexplain) {
                return;
            }
            if(role_qexplain&&role_qexplain.buttons.advancedCheck){//'高级搜索权限'
                if(this.state.imgClerkList===''){
                    axios.post(API.GET_PIC_USER_LIST).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({imgClerkList:res.data.list})
                        }else{
                            message.error(res.message)
                        }
                    },()=>{message.error("网络错误！")})
                }

                if(this.state.textClerkList===''){
                    axios.post(API.GET_TEXT_USER_LIST).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({textClerkList:res.data.list})
                        }else{
                            message.error(res.message)
                        }
                    },()=>{message.error("网络错误！")})
                }

                if(this.state.imgClerkCheckList===''){
                    axios.post(API.GET_PIC_CHECKUSER_LIST).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({imgClerkCheckList:res.data.list})
                        }else{
                            message.error(res.message)
                        }
                    },()=>{message.error("网络错误！")})
                }
                if(this.state.textClerkCheckList===''){
                    axios.post(API.GET_TEXT_CHECKUSER_LIST).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({textClerkCheckList:res.data.list})
                        }else{
                            message.error(res.message)
                        }
                    },()=>{message.error("网络错误！")})
                }
            }

            //任务的9个阶段显示哪几个

            this.columnsToDisplay = {
                pre_assign: getFilterColumns(role_qexplain, 'pre_assign'),
                img_explain: getFilterColumns(role_qexplain, 'img_explain'),
                pre_img_explain_check: getFilterColumns(role_qexplain, 'pre_img_explain_check'),
                img_explain_check: getFilterColumns(role_qexplain, 'img_explain_check'),
                img_explain_rework: getFilterColumns(role_qexplain, 'img_explain_rework'),
                pre_text_explain: getFilterColumns(role_qexplain, 'pre_text_explain'),
                text_explain: getFilterColumns(role_qexplain, 'text_explain'),
                pre_text_explain_check: getFilterColumns(role_qexplain, 'pre_text_explain_check'),

                text_explain_check: getFilterColumns(role_qexplain, 'text_explain_check'),
                text_explain_rework: getFilterColumns(role_qexplain, 'text_explain_rework'),
                text_explain_pass: getFilterColumns(role_qexplain, 'text_explain_pass'),

                text_explain_onlineing: getFilterColumns(role_qexplain, 'text_explain_onlineing'),
                text_explain_online_success: getFilterColumns(role_qexplain, 'text_explain_online_success'),
                text_explain_online_fail: getFilterColumns(role_qexplain, 'text_explain_online_fail'),
            }

            this.state.columns = this.columnsToDisplay['pre_assign']
            //设置选中的第一列
            let col = role_qexplain.columns
            let current = 'text_explain_online_fail'
            if(col.length){
                for(let i=col.length-1;i>=0;i--){
                    col[i].forEach(d=>{
                        if(d>0){
                            current =STAGE_MAP_REVERES[i]
                        }
                    })
                }
            }
            this.state.columns = this.columnsToDisplay[current]
            this.props.setCurrent(current)
            this.getTastList(current)


        }
    }
    componentDidMount(){
        if(this.props.user.role_qexplain){
            let newProps  = this.props
            let role_qexplain = newProps.user.role_qexplain
            if (!role_qexplain) {
                return;
            }
            if(role_qexplain&&role_qexplain.buttons.advancedCheck){//'高级搜索权限'
                if(this.state.imgClerkList===''){
                    axios.post(API.GET_PIC_USER_LIST).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({imgClerkList:res.data.list})
                        }else{
                            message.error(res.message)
                        }
                    },()=>{message.error("网络错误！")})
                }

                if(this.state.textClerkList===''){
                    axios.post(API.GET_TEXT_USER_LIST).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({textClerkList:res.data.list})
                        }else{
                            message.error(res.message)
                        }
                    },()=>{message.error("网络错误！")})
                }

                if(this.state.imgClerkCheckList===''){
                    axios.post(API.GET_PIC_CHECKUSER_LIST).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({imgClerkCheckList:res.data.list})
                        }else{
                            message.error(res.message)
                        }
                    },()=>{message.error("网络错误！")})
                }
                if(this.state.textClerkCheckList===''){
                    axios.post(API.GET_TEXT_CHECKUSER_LIST).then((res)=>{
                        res = res.data
                        if (res.code === 0) {
                            this.setState({textClerkCheckList:res.data.list})
                        }else{
                            message.error(res.message)
                        }
                    },()=>{message.error("网络错误！")})
                }
            }



            //任务的9个阶段显示哪几个
            this.columnsToDisplay = {
                pre_assign: getFilterColumns(role_qexplain, 'pre_assign'),
                img_explain: getFilterColumns(role_qexplain, 'img_explain'),
                pre_img_explain_check: getFilterColumns(role_qexplain, 'pre_img_explain_check'),
                img_explain_check: getFilterColumns(role_qexplain, 'img_explain_check'),
                img_explain_rework: getFilterColumns(role_qexplain, 'img_explain_rework'),
                pre_text_explain: getFilterColumns(role_qexplain, 'pre_text_explain'),
                text_explain: getFilterColumns(role_qexplain, 'text_explain'),
                pre_text_explain_check: getFilterColumns(role_qexplain, 'pre_text_explain_check'),

                text_explain_check: getFilterColumns(role_qexplain, 'text_explain_check'),
                text_explain_rework: getFilterColumns(role_qexplain, 'text_explain_rework'),
                text_explain_pass: getFilterColumns(role_qexplain, 'text_explain_pass'),

                text_explain_onlineing: getFilterColumns(role_qexplain, 'text_explain_onlineing'),
                text_explain_online_success: getFilterColumns(role_qexplain, 'text_explain_online_success'),
                text_explain_online_fail: getFilterColumns(role_qexplain, 'text_explain_online_fail'),
            }

            this.state.columns = this.columnsToDisplay['pre_assign']

            //设置选中的第一列
            let col = role_qexplain.columns
            let current = 'text_explain_online_fail'
            if(col.length){
                for(let i=col.length-1;i>=0;i--){
                    col[i].forEach(d=>{
                        if(d>0){
                            current =STAGE_MAP_REVERES[i]
                        }
                    })
                }
            }
            this.state.columns = this.columnsToDisplay[current]
            this.props.setCurrent(current)
            this.getTastList(current)

        }

    }
    componentWillUnmount() {


    }

    getTastList = (stage=this.props.current,callback)=>{
        setTimeout(()=>{
            let data = {
                page:this.state.page,
                pagesize:this.state.pagesize,
                search:this.state.search,
                stage:STAGE_MAP[stage],
                subject:this.props.user.subject||this.state.searchType,
                grade_part:this.props.grade_part,
                pic_check_user:this.state.pic_check_user,
                pic_user:this.state.pic_user,
                text_check_user:this.state.text_check_user,
                text_user:this.state.text_user,
            }
            axios.post(API.GET_EXPLAIN_TASK_LIST, data).then((res)=>{
                res = res.data;
                if (res.code === 0) {
                    this.setState({taskList:res.data.list||[],total:res.data.total})
                    callback&&callback()
                }else{
                    message.error(res.message);
                }
            },()=>{message.error("网络错误！")})
        },0)


    }
    onIsAdvanceSearch = ()=>{
        this.setState({advanceSearch:!this.state.advanceSearch})
    }
    showDeleteConfirm = () => {
        const ids = this.state.selectedRowKeys;
        const me = this;
        confirm({
            title: '确定删除任务？',
            content: '删除任务后不可恢复，确定删除吗？',
            onOk() {
                return new Promise((resolve, reject) => {
                    axios.post(API.EXPLAIN_TASK_DEL, {task_id:ids}).then((res)=>{
                        res = res.data;
                        if (res.code === 0) {
                            message.success("删除成功！");
                            resolve();
                            me.onRefreshList();
                        }else{
                            message.error(res.message);
                            reject();
                        }
                    },()=>{message.error("删除失败！")})
                })
            },
            onCancel() {},
        });
    }
    onShow = () => {
        this.setState({visible:true,taskId:''})

    }

    onCancel = () => {
        this.setState({visible:false})
    }
    handleClick = (e) => {
        this.state.selectedRowKeys = [];
        this.props.setCurrent(e.key)
        this.getTastList(e.key,()=>{
            this.setState({
                columns:this.columnsToDisplay[e.key],
            });
        })
    }
    onSelectChange = (selectedRowKeys,dsd) => {//表格行的选则框
        this.setState({ selectedRowKeys:selectedRowKeys });
    }
    onRefreshList = () => {
        this.state.selectedRowKeys = [];
        this.getTastList()
    }
    onPageChange = (val) => {
        this.setState({page:val})
        console.log(val)
        this.onRefreshList()
        document.querySelector('.questionListScroll').scrollTop=0
    }
    onAdvanceSearch = () => {
        console.log(this.state.pic_user)
        this.setState({page:1})
        this.state.page = 1
        this.onRefreshList()
    }
    onSearch = () => {
        this.setState({
            page:1,
            pic_check_user:'',
            pic_user:'',
            text_check_user:'',
            text_user:'',
        })
        setTimeout(()=>{
            this.onRefreshList()
        },0)
    }
    clearSearch = () => {
        this.setState({
            page:1,
            pic_check_user:'',
            pic_user:'',
            text_check_user:'',
            text_user:'',
            search:'',
        })
        setTimeout(()=>{
            this.onRefreshList()
        },0)
    }
    //打开分配编写解析组
    assignImgGroup=()=>{
        this.setState({assignImgGroup:true})
        if(this.state.imgGroupList===''){
            axios.post(API.GET_PIC_GROUP_LIST, {}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({imgGroupList:res.data.list})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }
    }
    //分配编写解析组
    onAssignImgGroup=()=>{
        if(this.state.imgGroup){
            axios.post(API.ASSIGN_PIC_GROUP, {task_id:this.state.selectedRowKeys,group_id:this.state.imgGroup}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({imgGroup:'',assignImgGroup:false})
                    this.onRefreshList();

                }else{
                    message.error(res.message);
                }
            },()=>{
                message.error("网络错误！");
            })
        }else{
            message.error("请选择组！")
        }
    }


    //分配解析员 打开
    assignImgClerk =()=>{
        this.setState({assignImgClerk:true})
        if(this.state.imgClerkList===''){
            axios.post(API.GET_PIC_USER_LIST).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({imgClerkList:res.data.list})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }
    }

    //分配编写解析员
    onAssignImgClerk = () => {
        if(this.state.imgClerk){
            axios.post(API.ASSIGN_PIC_USER, {task_id:this.state.selectedRowKeys,user_id:this.state.imgClerk}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({imgClerk:'',assignImgClerk:false,});
                    this.onRefreshList();
                }else{
                    message.error(res.message);
                }
            })
        }else {
            message.error("请选择录入员！")
        }

    }
    //修改解析员
    modAssignImgClerk =()=>{
        this.setState({modAssignImgClerk:true})
        if(this.state.imgClerkList===''){
            axios.post(API.GET_PIC_USER_LIST).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({imgClerkList:res.data.list})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }
    }
    //修改编写解析员
    onModAssignImgClerk = () => {
        if(this.state.imgClerk){
            axios.post(API.MOD_ASSIGN_PIC_USER, {task_id:this.state.selectedRowKeys,user_id:this.state.imgClerk}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({imgClerk:'',modAssignImgClerk:false,});
                    this.onRefreshList();
                }else{
                    message.error(res.message);
                }
            })
        }else {
            message.error("请选择录入员！")
        }

    }
    //图片录入提交
    onImgExplainSubmit=()=>{
        let task_ids = this.state.selectedRowKeys
        let allDo = false
        task_ids.forEach((d)=>{
            this.state.taskList.forEach((task)=>{
                if(d==task.task_id){
                    if(task.question_count_pic<task.question_count){
                        allDo = true
                    }
                }
            })
        })

        if(allDo){
            this.setState({imgExplainSubmitNotAllDo:true})
        }else{
            axios.post(API.PIC_ENTRY_SUBMIT, {task_id:this.state.selectedRowKeys}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    message.success("提交成功！")
                    this.onRefreshList();
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }

    }
    imgExplainSubmitNotAllDoOnOk=()=>{
        this.setState({imgExplainSubmitNotAllDo:false})
        axios.post(API.PIC_ENTRY_SUBMIT, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})


    }
    //返工时的图片任务提交
    onImgExplainReSubmit=()=>{
        axios.post(API.PIC_ENTRY_RESUBMIT, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //分配编写解析审核员
    assignImgClerkCheck =()=>{
        this.setState({assignImgClerkCheck:true})
        if(this.state.imgClerkCheckList===''){
            axios.post(API.GET_PIC_CHECKUSER_LIST).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({imgClerkCheckList:res.data.list})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }
    }

    // 分配编写解析审核员
    onAssignImgClerkCheck = () => {
        if(this.state.imgClerkCheck){
            axios.post(API.ASSIGN_PIC_CHECK_USER, {task_id:this.state.selectedRowKeys,user_id:this.state.imgClerkCheck}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({imgClerkCheck:'',assignImgClerkCheck:false,});
                    this.onRefreshList();
                }else{
                    message.error(res.message);
                }
            })
        }else {
            message.error("请选择编写解析审核员！")
        }
    }

    //编写解析审核提交
    onImgExplainCheckSubmit=()=>{
        axios.post(API.PIC_CHECK_PASS, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //编写解析审核返工
    onImgExplainCheckRework=()=>{
        axios.post(API.PIC_CHECK_REWORK, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("返工成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }

    //点击分配录解析组
    assignTextGroup =()=>{
        this.setState({assignTextGroup:true})
        if(this.state.textGroupList===''){
            axios.post(API.GET_TEXT_GROUP_LIST).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({textGroupList:res.data.list})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }
    }
    //点击分配录解析组中的ok
    onAssignTextGroup=()=>{
        if(this.state.textGroup){
            axios.post(API.ASSIGN_TEXT_GROUP, {task_id:this.state.selectedRowKeys,group_id:this.state.textGroup}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    message.success("提交成功！")
                    this.setState({textGroup:'',assignTextGroup:false})

                    this.onRefreshList();
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }

    }

    //点击分配录解析员
    assignTextClerk =()=>{
        this.setState({assignTextClerk:true})
        if(this.state.textClerkList===''){
            axios.post(API.GET_TEXT_USER_LIST).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({textClerkList:res.data.list})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }
    }
    //点击分配录解析员中的ok
    onAssignTextClerk=()=>{
        if(this.state.textClerk){
            axios.post(API.ASSIGN_TEXT_USER, {task_id:this.state.selectedRowKeys,user_id:this.state.textClerk}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    message.success("提交成功！")
                    this.setState({textClerk:'',assignTextClerk:false,});

                    this.onRefreshList();

                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }

    }

    //修改录解析员
    modAssignTextClerk =()=>{
        this.setState({modAssignTextClerk:true})
        if(this.state.textClerkList===''){
            axios.post(API.GET_TEXT_USER_LIST).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({textClerkList:res.data.list})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }
    }
    //修改录解析员
    onModAssignTextClerk = () => {
        if(this.state.textClerk){
            axios.post(API.MOD_ASSIGN_TEXT_USER, {task_id:this.state.selectedRowKeys,user_id:this.state.textClerk}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({textClerk:'',modAssignTextClerk:false,});
                    this.onRefreshList();
                }else{
                    message.error(res.message);
                }
            })
        }else {
            message.error("请选择录入员！")
        }

    }

    //录解析 提交
    onTextExplainSubmit=()=>{
        axios.post(API.TEXT_ENTRY_SUBMIT, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //分配录解析审核员
    assignTextClerkCheck =()=>{
        this.setState({assignTextClerkCheck:true})
        if(this.state.textClerkCheckList===''){
            axios.post(API.GET_TEXT_CHECKUSER_LIST).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({textClerkCheckList:res.data.list})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }
    }
    // 分配录解析审核员 ok
    onAssignTextClerkCheck = () => {
        if(this.state.textClerkCheck){
            axios.post(API.ASSIGN_TEXT_CHECK_USER, {task_id:this.state.selectedRowKeys,user_id:this.state.textClerkCheck}).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    this.setState({textClerkCheck:'',assignTextClerkCheck:false,});
                    this.onRefreshList();
                }else{
                    message.error(res.message);
                }
            })
        }else {
            message.error("请选择编写解析审核员！")
        }
    }


    //录解析审核提交
    onTextExplainCheckSubmit=()=>{
        axios.post(API.TEXT_CHECK_PASS, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //录解析审核返工
    onTextExplainCheckRework=()=>{
        axios.post(API.TEXT_CHECK_REWORK, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("返工成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //返工时的文字任务提交
    onTextExplainReSubmit=()=>{
        axios.post(API.TEXT_ENTRY_RESUBMIT, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }

    //入库操作
    onTextExplainOnLine=()=>{
        axios.post(API.EXPLAIN_TASK_ONLINE, {task_id:this.state.selectedRowKeys}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success("入库操作提交成功！")
                this.onRefreshList();
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }

    onStartChange = (value) => {
        this.setState({exportStartTime:value});
    }

    onEndChange = (value) => {
        this.setState({exportEndTime:value});
    }
    //任务统计
    onGetExoprtStatic = ()=>{
        var form = $("<form>");   //定义一个form表单
        form.attr('style', 'display:none');   //在form表单中添加查询参数
        form.attr('target', '');
        form.attr('method', 'post');
        form.attr('action', API.EXPLAIN_TASK_EXPORT);
        var input1 = $('<input>');
        input1.attr('type', 'hidden');
        input1.attr('name', 'start_time');
        if(this.state.exportStartTime){
            input1.attr('value', this.state.exportStartTime.format('YYYY-MM-DD'));
        }
        var input2 = $('<input>');
        input2.attr('type', 'hidden');
        input2.attr('name', 'end_time');
        if(this.state.exportEndTime){
            input2.attr('value', this.state.exportEndTime.format('YYYY-MM-DD'));
        }
        $('body').append(form);  //将表单放置在web中
        form.append(input1);   //将查询参数控件提交到表单上
        form.append(input2);
        form.submit();
        this.setState({exportStatic:false})
    }

    render(){
        let role_qexplain = this.props.user.role_qexplain
        if(!role_qexplain){return null}
        const data = [];
        this.state.taskList && this.state.taskList.forEach((val)=>{

            data.push({
                key: val.task_id,
                task_id:val.task_id,
                name:val.name,
                type:'章节',
                create_time: val.create_time && val.create_time.split(' ')[0],
                rework_time: val.rework_time_pic && val.rework_time_pic.split(' ')[0],
                status:val.stage_name && val.stage_name,
                statics:`${val.question_count} / ${val.question_count_pic}`,
                statics_check:`${val.question_count} / ${val.question_count_pic}/ ${~~val.question_count_pic_pass+~~val.question_count_pic_rework}`,
                statics_text: `${val.question_count} / ${val.question_count_text} `,
                statics_text_check: `${val.question_count} / ${val.question_count_text}/ ${~~val.question_count_text_pass+~~val.question_count_text_rework}`,
                passNum:`${val.question_count_pic_pass} / ${val.question_count_pic_rework} `,
                question_count_pic_pass:val.question_count_pic_pass,
                question_count_pic_rework:val.question_count_pic_rework,

                passNum_text:`${val.question_count_text_pass} / ${val.question_count_text_rework} `,
                question_count_text_pass:val.question_count_text_pass,
                question_count_text_rework:val.question_count_text_rework,

                imgExplain:`${val.pic_user_name&&val.pic_user_name}`,
                imgExplain_group:`${val.pic_group_admin_name&&val.pic_group_admin_name}`,
                imgExplainCheck:`${val.pic_check_user_name&&val.pic_check_user_name}`,

                textExplain:`${val.text_user_name&&val.text_user_name}`,
                textExplain_group:`${val.text_group_admin_name&&val.text_group_admin_name}`,
                textExplainCheck:`${val.text_check_user_name&&val.text_check_user_name}`,


            });
        })
        const {selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;

        const getOptionButton = ()=>{
            let result = '';
            switch (this.props.current){
                case 'pre_assign':
                    result =<Col span={12}>

                        {
                            role_qexplain.buttons.taskAdd===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" onClick={this.onShow}>创建任务</Button>

                        }
                        {this.state.visible && <CreateTask subject={this.props.user.subject} onCancel={this.onCancel} visible={this.state.visible} taskId={this.state.taskId} user={this.props.user} refresh={()=>{this.onRefreshList(1)}}/>}

                        {
                            role_qexplain.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.showDeleteConfirm}>删除任务</Button>

                        }
                        {
                            role_qexplain.buttons.taskAssignPicGroup===1 &&this.props.subject=="0"&&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignImgGroup}>分配小组</Button>
                        }
                        <Modal title="分配小组" visible={this.state.assignImgGroup} onOk={this.onAssignImgGroup} onCancel={()=>this.setState({assignImgGroup:false})}>
                            <span style={{marginLeft:30}}>分配小组：</span>
                            <Select
                                showSearch
                                placeholder="请选择小组"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({imgGroup:val})}}
                                value={this.state.imgGroup}

                            >
                                {
                                    this.state.imgGroupList&&this.state.imgGroupList.map(item =>
                                        <Option key={item.group_id} value={item.group_id.toString()}>{item.group_name}</Option>)
                                }
                            </Select>
                        </Modal>

                        {
                            role_qexplain.buttons.taskAssignPicUser===1 &&this.props.subject=="0"&&
                            // 分配录入员： 任务管理权限、组管理权限 可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignImgClerk}>分配编写解析员</Button>
                        }

                        <Modal title="分配编写解析员" visible={this.state.assignImgClerk} onOk={this.onAssignImgClerk} onCancel={()=>this.setState({assignImgClerk:false})}>
                            <span style={{marginLeft:30}}>分配编写解析员：</span>
                            <Select
                                showSearch
                                placeholder="请选择解析员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({imgClerk:val})}}
                                value={this.state.imgClerk}
                            >
                                {
                                    this.state.imgClerkList&&this.state.imgClerkList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>
                         {
                            role_qexplain.buttons.taskAssignTextUser===1&&(this.props.subject=="1"||this.props.subject=="2")&&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignTextClerk}>分配录解析员</Button>
                        }
                        <Modal title="分配录解析员" visible={this.state.assignTextClerk} onOk={this.onAssignTextClerk} onCancel={()=>this.setState({assignTextClerk:false})}>
                            <span style={{marginLeft:30}}>分配录解析员：</span>
                            <Select
                                showSearch
                                placeholder="请选择解析员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({textClerk:val})}}
                                value={this.state.textClerk}
                            >
                                {
                                    this.state.textClerkList&&this.state.textClerkList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>
                    
                    </Col>
                    break;
                case 'img_explain':
                    result =<Col span={12}>
                        {
                            role_qexplain.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.showDeleteConfirm}>删除任务</Button>

                        }
                        {
                            role_qexplain.buttons.picEntry===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onImgExplainSubmit}>提&nbsp;&nbsp;交</Button>
                        }

                        {
                            role_qexplain.buttons.taskAssignPicUserMod===1&&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.modAssignImgClerk}>分配编写解析员</Button>
                        }

                        <Modal title="分配编写解析员" visible={this.state.modAssignImgClerk} onOk={this.onModAssignImgClerk} onCancel={()=>this.setState({modAssignImgClerk:false})}>
                            <span style={{marginLeft:30}}>分配编写解析员：</span>
                            <Select
                                showSearch
                                placeholder="请选择解析员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({imgClerk:val})}}
                                value={this.state.imgClerk}
                            >
                                {
                                    this.state.imgClerkList&&this.state.imgClerkList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>
                    </Col>
                    break;
                case 'pre_img_explain_check':
                    result =<Col span={12}>
                        {
                            role_qexplain.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.showDeleteConfirm}>删除任务</Button>

                        }
                        {
                            role_qexplain.buttons.taskAssignPicCheckUser===1&&  //
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignImgClerkCheck}>分配解析审核人</Button>
                        }

                        <Modal title="待编写解析审核" visible={this.state.assignImgClerkCheck} onOk={this.onAssignImgClerkCheck} onCancel={()=>this.setState({assignImgClerkCheck:false})}>
                            <span style={{marginLeft:30}}>分配编写解析员：</span>
                            <Select
                                showSearch
                                placeholder="请选择审核员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({imgClerkCheck:val})}}
                                value={this.state.imgClerkCheck}
                            >
                                {
                                    this.state.imgClerkCheckList&&this.state.imgClerkCheckList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>


                    </Col>
                    break;
                case 'img_explain_check':
                    result =<Col span={12}>
                        {
                            role_qexplain.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.showDeleteConfirm}>删除任务</Button>

                        }

                        {
                            role_qexplain.buttons.picCheck===1&&//编写解析中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onImgExplainCheckSubmit}>通&nbsp;&nbsp;过</Button>
                        }
                        {
                            role_qexplain.buttons.picCheck===1&&//编写解析中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onImgExplainCheckRework}>返&nbsp;&nbsp;工</Button>
                        }

                        {
                            role_qexplain.buttons.taskAssignPicCheckUser===1&&  //
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignImgClerkCheck}>分配解析审核人</Button>
                        }
                        <Modal title="待编写解析审核" visible={this.state.assignImgClerkCheck} onOk={this.onAssignImgClerkCheck} onCancel={()=>this.setState({assignImgClerkCheck:false})}>
                            <span style={{marginLeft:30}}>分配编写解析员：</span>
                            <Select
                                showSearch
                                placeholder="请选择审核员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({imgClerkCheck:val})}}
                                value={this.state.imgClerkCheck}
                            >
                                {
                                    this.state.imgClerkCheckList&&this.state.imgClerkCheckList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>
                    </Col>
                    break;

                case 'img_explain_rework':
                    result =<Col span={12}>
                        {
                            role_qexplain.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.showDeleteConfirm}>删除任务</Button>

                        }
                        {
                            role_qexplain.buttons.picEntry===1&&//编写解析中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onImgExplainReSubmit}>提&nbsp;&nbsp;交</Button>
                        }

 

                    </Col>
                    break;

                case 'pre_text_explain':
                    result =<Col span={12}>
                        {
                            role_qexplain.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.showDeleteConfirm}>删除任务</Button>

                        }
                        {
                            role_qexplain.buttons.taskAssignTextGroup===1&&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignTextGroup}>分配录解析组</Button>
                        }
                        <Modal title="分配录解析组" visible={this.state.assignTextGroup} onOk={this.onAssignTextGroup} onCancel={()=>this.setState({assignTextGroup:false})}>
                            <span style={{marginLeft:30}}>分配录解析组：</span>
                            <Select
                                showSearch
                                placeholder="请选择解析组"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({textGroup:val})}}
                                value={this.state.textGroup}
                            >
                                {
                                    this.state.textGroupList&&this.state.textGroupList.map(item =>
                                        <Option key={item.group_id} value={item.group_id.toString()}>{item.group_name}</Option>)
                                }
                            </Select>
                        </Modal>

                        {
                            role_qexplain.buttons.taskAssignTextUser===1&&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignTextClerk}>分配录解析员</Button>
                        }
                        <Modal title="分配录解析员" visible={this.state.assignTextClerk} onOk={this.onAssignTextClerk} onCancel={()=>this.setState({assignTextClerk:false})}>
                            <span style={{marginLeft:30}}>分配录解析员：</span>
                            <Select
                                showSearch
                                placeholder="请选择解析员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({textClerk:val})}}
                                value={this.state.textClerk}
                            >
                                {
                                    this.state.textClerkList&&this.state.textClerkList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>
                    </Col>
                    break;
                case 'text_explain':
                    result =<Col span={12}>
                        {
                            role_qexplain.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.showDeleteConfirm}>删除任务</Button>

                        }
                        {
                            role_qexplain.buttons.textEntry===1&&//编写解析中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onTextExplainSubmit}>提&nbsp;&nbsp;交</Button>
                        }

                        {
                            role_qexplain.buttons.taskAssignTextUserMod===1&&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.modAssignTextClerk}>分配录解析员</Button>
                        }

                        <Modal title="分配录解析员" visible={this.state.modAssignTextClerk} onOk={this.onModAssignTextClerk} onCancel={()=>this.setState({modAssignTextClerk:false})}>
                            <span style={{marginLeft:30}}>分配录解析员：</span>
                            <Select
                                showSearch
                                placeholder="请选择解析员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({textClerk:val})}}
                                value={this.state.textClerk}
                            >
                                {
                                    this.state.textClerkList&&this.state.textClerkList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>
                    </Col>
                    break;
                case 'pre_text_explain_check':
                    result =<Col span={12}>
                        {
                            role_qexplain.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.showDeleteConfirm}>删除任务</Button>

                        }
                        {
                            role_qexplain.buttons.taskAssignTextCheckUser===1&&  //
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignTextClerkCheck}>分配录解析审核员</Button>
                        }

                        <Modal title="分配录解析审核员" visible={this.state.assignTextClerkCheck} onOk={this.onAssignTextClerkCheck} onCancel={()=>this.setState({assignTextClerkCheck:false})}>
                            <span style={{marginLeft:30}}>分配录解析审核员：</span>
                            <Select
                                showSearch
                                placeholder="请选择审核员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({textClerkCheck:val})}}
                                value={this.state.textClerkCheck}
                            >
                                {
                                    this.state.textClerkCheckList&&this.state.textClerkCheckList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>


                    </Col>
                    break;
                case 'text_explain_check':
                    result =<Col span={12}>
                        {
                            role_qexplain.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.showDeleteConfirm}>删除任务</Button>

                        }
                        {
                            role_qexplain.buttons.textCheck===1&&//编写解析中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onTextExplainCheckSubmit}>通&nbsp;&nbsp;过</Button>
                        }
                        {
                            role_qexplain.buttons.textCheck===1&&//编写解析中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onTextExplainCheckRework}>返&nbsp;&nbsp;工</Button>
                        }
                        {
                            role_qexplain.buttons.taskAssignTextCheckUser===1&&  //
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.assignTextClerkCheck}>分配录解析审核员</Button>
                        }
                        <Modal title="分配录解析审核员" visible={this.state.assignTextClerkCheck} onOk={this.onAssignTextClerkCheck} onCancel={()=>this.setState({assignTextClerkCheck:false})}>
                            <span style={{marginLeft:30}}>分配录解析审核员：</span>
                            <Select
                                showSearch
                                placeholder="请选择审核员"
                                style={{width:'61.4%'}}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(val)=>{this.setState({textClerkCheck:val})}}
                                value={this.state.textClerkCheck}
                            >
                                {
                                    this.state.textClerkCheckList&&this.state.textClerkCheckList.map(item =>
                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name + '-' + item.mobile}</Option>)
                                }
                            </Select>
                        </Modal>

                    </Col>
                    break;
                case 'text_explain_rework':
                    result =<Col span={12}>
                        {
                            role_qexplain.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.showDeleteConfirm}>删除任务</Button>

                        }
                        {
                            role_qexplain.buttons.textEntry===1&&//编写解析中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onTextExplainReSubmit}>提&nbsp;&nbsp;交</Button>
                        }

                    </Col>
                    break;
                case 'text_explain_pass':
                    result =<Col span={12}>
                        {
                            role_qexplain.buttons.taskDel===1 &&
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.showDeleteConfirm}>删除任务</Button>

                        }
                        {
                            role_qexplain.buttons.taskOnline===1&&//编写解析中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onTextExplainOnLine}>入&nbsp;&nbsp;库</Button>
                        }
                    </Col>
                    break;
                case 'text_explain_onlineing':
                    result =<Col span={12}>

                    </Col>
                    break;
                case 'text_explain_online_success':
                    result =<Col span={12}>

                    </Col>
                    break;
                case 'text_explain_online_fail':
                    result =<Col span={12}>
                        {
                            role_qexplain.buttons.taskOnline===1&&//编写解析中的提交：任务管理权限 组管理权限  可显示
                            <Button style={{fontSize: 12,marginRight:10}} type="primary" disabled={!hasSelected} onClick={this.onTextExplainOnLine}>入&nbsp;&nbsp;库</Button>
                        }
                    </Col>
                    break;
                default:
                    result =<Col span={12} style={this.state.advanceSearch?{marginTop:66}:{}}></Col>
                    break;
            }
            return result

        }
        ///导出时间
        let disabledEndDate = (endValue) => {
            const startValue = this.state.exportStartTime;
            if (!endValue || !startValue) {
                return false;
            }
            return endValue.valueOf() <= startValue.valueOf();
        }
        let disabledStartDate = (current) => {
            return current && current.valueOf() >= Date.now();
        }
        let width = 0;
        for(let key in this.columnsToDisplay[this.props.current]){
            width += this.columnsToDisplay[this.props.current][key].width;
        }
        this.state.totalWidth=width+90
        return(
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>题目管理</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>题目解析</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{marginTop:15}}>
                    <Col span={24}>
                        {
                            role_qexplain.buttons.advancedCheck===1?
                                // this.state.advanceSearch?  //不能展开 直接默认展开
                                <div className={'searchHead'}>
                                    <Row style={{marginBottom:5}}>

                                        <div style={{fontSize: 14,marginLeft:'20px',display:'inline-block'}}>
                                            <label style={{width:'80px',display:'inline-block'}} htmlFor="search_pic_explain">编写解析人：</label>
                                            <Select
                                                value={this.state.pic_user}
                                                style={{ width: 120 }}
                                                onChange={(val)=>{this.setState({pic_user:val})}}
                                                showSearch
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                id="search_pic_explain">
                                                <Option key={-1} value={'-1'}>所有</Option>
                                                {
                                                    this.state.imgClerkList&&this.state.imgClerkList.map(item =>
                                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name}</Option>)
                                                }
                                            </Select>
                                        </div>
                                        <div style={{fontSize: 14,marginLeft:'40px',display:'inline-block'}}>
                                            <label style={{width:'80px',display:'inline-block'}} htmlFor="search_pic_explain_check">编写审核人：</label>
                                            <Select value={this.state.pic_check_user}
                                                    style={{ width: 120 }}
                                                    showSearch
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                    onChange={(val)=>{this.setState({pic_check_user:val})}}
                                                    id="search_pic_explain_check">
                                                <Option key={-1} value={'-1'}>所有</Option>
                                                {
                                                    this.state.imgClerkCheckList&&this.state.imgClerkCheckList.map(item =>
                                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name}</Option>)
                                                }
                                            </Select>
                                        </div>
                                        {/*录解析*/}
                                        <div style={{fontSize: 14,marginLeft:'40px',display:'inline-block'}}>
                                            <label style={{width:'80px',display:'inline-block'}} htmlFor="search_text_explain">录解析人：</label>
                                            <Select showSearch
                                                    value={this.state.text_user}
                                                    style={{ width: 120 }}
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                    onChange={(val)=>{this.setState({text_user:val})}} id="search_text_explain">
                                                <Option key={-1} value={'-1'}>所有</Option>
                                                {
                                                    this.state.textClerkList&&this.state.textClerkList.map(item =>
                                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name}</Option>)
                                                }
                                            </Select>
                                        </div>
                                        <div style={{fontSize: 14,marginLeft:'40px',display:'inline-block'}}>
                                            <label style={{width:'80px',display:'inline-block'}} htmlFor="search_text_explain_check">录审核人：</label>
                                            <Select showSearch
                                                    value={this.state.text_check_user}
                                                    style={{ width: 120 }}
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                    onChange={(val)=>{this.setState({text_check_user:val})}}
                                                    id="search_text_explain_check">
                                                <Option key={-1} value={'-1'}>所有</Option>
                                                {
                                                    this.state.textClerkCheckList&&this.state.textClerkCheckList.map(item =>
                                                        <Option key={item.user_id} value={item.user_id.toString()}>{item.name}</Option>)
                                                }
                                            </Select>
                                        </div>

                                    </Row>
                                    <Row style={{marginTop:10}}>
                                        <div style={{fontSize: 14,marginLeft:'20px',display:'inline-block'}}>
                                            {/*<Icon style={{fontSize:20,lineHeight:'28px',marginRight:5,color:'#d9d9d9',verticalAlign:'bottom'}} type="up-circle-o" onClick={this.onIsAdvanceSearch}/>*/}

                                            {/*<div style={{fontSize: 14,marginRight:'20px',display:'inline-block'}}>*/}
                                                {/*<label style={{width:'70px',display:'inline-block'}} htmlFor="search_type">学科 ：</label>*/}
                                                {/*<Select value={this.state.searchType} style={{ width: 120 }} onChange={(val)=>{this.setState({searchType:val})}} id="search_type">*/}
                                                    {/*<Option value="0">数学</Option>*/}
                                                    {/*<Option value="1">英语</Option>*/}
                                                    {/*<Option value="2">语文</Option>*/}
                                                {/*</Select>*/}
                                            {/*</div>*/}
                                            <Search
                                                placeholder="输入关键字"
                                                style={{ width: 520,marginRight:10}}
                                                onSearch={this.onAdvanceSearch}
                                                onChange={(e)=>this.setState({search:e.target.value})}
                                                value={this.state.search}
                                            />
                                            <Button style={{fontSize: 12,marginLeft:'20px'}} type="primary" onClick={this.onAdvanceSearch}>搜索</Button>
                                            <Button style={{fontSize: 12,marginLeft:'120px'}} type="danger" onClick={this.clearSearch}>清空</Button>
                                        </div>
                                    </Row>
                                </div>:
                                <div style={{fontSize: 14,marginLeft:'20px',display:'inline-block',float:'left'}}>
                                    {
                                        // role_qexplain.buttons.advancedCheck===1&& //不能展开 直接默认展开
                                        // <Icon style={{fontSize:20,lineHeight:'28px',marginRight:5,color:'#d9d9d9',verticalAlign:'bottom'}} type="down-circle-o" onClick={this.onIsAdvanceSearch}/>

                                    }
                                    <Search
                                        placeholder="输入关键字"
                                        style={{width:220,marginRight:10}}
                                        onSearch={this.onSearch}
                                        value={this.state.search}
                                        onChange={(e)=>this.setState({search:e.target.value})}
                                    />
                                    <Button style={{fontSize: 12,marginLeft:'20px'}} type="primary" onClick={this.onSearch}>搜索</Button>
                                    <Button style={{fontSize: 12,marginLeft:'120px'}} type="danger" onClick={this.clearSearch}>清空</Button>
                                </div>
                        }
                    </Col>
                </Row>
                <Row style={{marginTop:10,maxWidth:1280}}>
                    <Col span={24}>
                        <div style={{fontSize:12}}>
                            <Menu
                                onClick={this.handleClick}
                                selectedKeys={[this.props.current]}
                                mode="horizontal"
                                style={{marginBottom:5,backgroundColor:'#f7f7f7',padding:'0 15px',borderRadius:6}}
                            >
                                {
                                    role_qexplain.columns[0].some(d=>d>0)&&
                                    <Menu.Item key="pre_assign">待分配</Menu.Item>
                                }
                                {
                                    role_qexplain.columns[1].some(d=>d>0)&&
                                    <Menu.Item key="img_explain">编写解析</Menu.Item>
                                }
                                {
                                    role_qexplain.columns[2].some(d=>d>0)&&
                                    <Menu.Item key="pre_img_explain_check">待编写解析审核</Menu.Item>
                                }
                                {
                                    role_qexplain.columns[3].some(d=>d>0)&&
                                    <Menu.Item key="img_explain_check">编写解析审核</Menu.Item>
                                }
                                {
                                    role_qexplain.columns[4].some(d=>d>0)&&
                                    <Menu.Item key="img_explain_rework">编写解析返工</Menu.Item>
                                }
                                {
                                    role_qexplain.columns[5].some(d=>d>0)&&
                                    <Menu.Item key="pre_text_explain">待录解析</Menu.Item>
                                }
                                {
                                    role_qexplain.columns[6].some(d=>d>0)&&
                                    <Menu.Item key="text_explain">录解析</Menu.Item>
                                }
                                {
                                    role_qexplain.columns[7].some(d=>d>0)&&
                                    <Menu.Item key="pre_text_explain_check">待录解析审核</Menu.Item>
                                }
                                {
                                    role_qexplain.columns[8].some(d=>d>0)&&
                                    <Menu.Item key="text_explain_check">录解析审核</Menu.Item>
                                }
                                {
                                    role_qexplain.columns[9].some(d=>d>0)&&
                                    <Menu.Item key="text_explain_rework">录解析返工</Menu.Item>
                                }
                                {
                                    role_qexplain.columns[10].some(d=>d>0)&&
                                    <Menu.Item key="text_explain_pass">审核完成</Menu.Item>
                                }
                                {
                                    role_qexplain.columns[11].some(d=>d>0)&&
                                    <Menu.Item key="text_explain_onlineing">入库中</Menu.Item>
                                }
                                {
                                    role_qexplain.columns[12].some(d=>d>0)&&
                                    <Menu.Item key="text_explain_online_success">入库成功</Menu.Item>
                                }
                                {
                                    role_qexplain.columns[13].some(d=>d>0)&&
                                    <Menu.Item key="text_explain_online_fail">入库失败</Menu.Item>
                                }


                            </Menu>
                        </div>
                    </Col>

                </Row>
                <Row style={{marginBottom:5,maxWidth:1280}}>
                    {
                        getOptionButton()
                    }
                    <Col span={12}>
                        <div style={{fontSize:12,float:'right'}}>
                            {
                                role_qexplain.buttons.errorDuty===1 &&//解析检错
                                <Link className='ant-btn ant-btn-primary' style={{fontSize: 12,marginRight:30,background:'red',outline:'none',border:'none',verticalAlign:'middle',lineHeight:'28px'}} to={`/questionmanage/questionexplain/duty/`}>解析检错</Link>
                            }

                            {
                                role_qexplain.buttons.taskStatics===1 &&//导出
                                <Button style={{fontSize: 12}} type="primary" onClick={()=>this.setState({exportStatic:true})}>任务结算导出</Button>
                            }
                            <Modal title="任务结算导出" visible={this.state.exportStatic} onOk={this.onGetExoprtStatic} onCancel={()=>this.setState({exportStatic:false})}>
                                <DatePicker
                                    format="YYYY-MM-DD"
                                    placeholder={'开始时间'}
                                    style={{marginRight:20}}
                                    onChange={this.onStartChange}
                                    disabledDate={disabledStartDate}
                                />
                                <DatePicker
                                    format="YYYY-MM-DD"
                                    placeholder={'结束时间'}
                                    onChange={this.onEndChange}
                                    disabledDate={disabledEndDate}
                                />
                            </Modal>
                        </div>
                    </Col>
                </Row>

                <Modal title="分配录解析审核员" visible={this.state.imgExplainSubmitNotAllDo} onOk={this.imgExplainSubmitNotAllDoOnOk} onCancel={()=>this.setState({imgExplainSubmitNotAllDo:false})}>
                    <span style={{marginLeft:30}}>未完成所有题目，是否提交？</span>

                </Modal>
                <Row style={{maxWidth:this.state.totalWidth,minWidth:'100%'}}>
                    <Table rowSelection={rowSelection} columns={this.state.columns} dataSource={data} pagination={{current:this.state.page,pageSize:this.state.pagesize,total:this.state.total,onChange:this.onPageChange }} loading={this.state.loading} scroll={{ x: this.state.totalWidth }}/>
                </Row>
            </div>
        );
    }
}
const mapStateTopProps = (state) => {

    return {
        user:state.user,
        current:state.questionManage.questionExplain.current,
        subject: state.user.subject,
    };
}
const mapDispatchToProps = dispatch => {
    return {
        setCurrent:(val)=>{
            dispatch(action.setCurrent(val));
        },
    }
};

export default connect(mapStateTopProps,mapDispatchToProps)(MissionList);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_explain/explain_task_list/view.js